// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEnquiry_root__RPzMU","marketplaceColorStroke":"IconEnquiry_marketplaceColorStroke__25ixW"};